import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getTinymedicPatientOrders } from 'app/entities/tinymedic-patient-order/tinymedic-patient-order.reducer';
import { getEntities as getTenants } from 'app/entities/tenant/tenant.reducer';
import { BidStatus } from 'app/shared/model/enumerations/bid-status.model';
import { BillFor } from 'app/shared/model/enumerations/bill-for.model';
import { PatientType } from 'app/shared/model/enumerations/patient-type.model';
import { createEntity, getEntity, reset, updateEntity } from './tenant-bids.reducer';

export const TenantBidsUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const tinymedicPatientOrders = useAppSelector(state => state.tinymedicPatientOrder.entities);
  const tenants = useAppSelector(state => state.tenant.entities);
  const tenantBidsEntity = useAppSelector(state => state.tenantBids.entity);
  const loading = useAppSelector(state => state.tenantBids.loading);
  const updating = useAppSelector(state => state.tenantBids.updating);
  const updateSuccess = useAppSelector(state => state.tenantBids.updateSuccess);
  const bidStatusValues = Object.keys(BidStatus);
  const billForValues = Object.keys(BillFor);
  const patientTypeValues = Object.keys(PatientType);

  const handleClose = () => {
    navigate(`/tenant-bids${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getTinymedicPatientOrders({}));
    dispatch(getTenants({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.bidSubmittedDate !== undefined && typeof values.bidSubmittedDate !== 'number') {
      values.bidSubmittedDate = Number(values.bidSubmittedDate);
    }
    if (values.bidAcceptedDate !== undefined && typeof values.bidAcceptedDate !== 'number') {
      values.bidAcceptedDate = Number(values.bidAcceptedDate);
    }
    if (values.totalCost !== undefined && typeof values.totalCost !== 'number') {
      values.totalCost = Number(values.totalCost);
    }
    if (values.discount !== undefined && typeof values.discount !== 'number') {
      values.discount = Number(values.discount);
    }
    if (values.cgst !== undefined && typeof values.cgst !== 'number') {
      values.cgst = Number(values.cgst);
    }
    if (values.sgst !== undefined && typeof values.sgst !== 'number') {
      values.sgst = Number(values.sgst);
    }
    if (values.roundOffVal !== undefined && typeof values.roundOffVal !== 'number') {
      values.roundOffVal = Number(values.roundOffVal);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }
    if (values.deliveryCost !== undefined && typeof values.deliveryCost !== 'number') {
      values.deliveryCost = Number(values.deliveryCost);
    }
    if (values.grossAmount !== undefined && typeof values.grossAmount !== 'number') {
      values.grossAmount = Number(values.grossAmount);
    }
    if (values.bidDate !== undefined && typeof values.bidDate !== 'number') {
      values.bidDate = Number(values.bidDate);
    }

    const entity = {
      ...tenantBidsEntity,
      ...values,
      tinymedicPatientOrder: tinymedicPatientOrders.find(it => it.id.toString() === values.tinymedicPatientOrder?.toString()),
      tenant: tenants.find(it => it.id.toString() === values.tenant?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          status: 'BID_SUBMITTED',
          billFor: 'BUSINESS',
          patientType: 'TINYMEDIC',
          ...tenantBidsEntity,
          tinymedicPatientOrder: tenantBidsEntity?.tinymedicPatientOrder?.id,
          tenant: tenantBidsEntity?.tenant?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.tenantBids.home.createOrEditLabel" data-cy="TenantBidsCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.tenantBids.home.createOrEditLabel">Create or edit a TenantBids</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="tenant-bids-id"
                  label={translate('tinyMedicRestApp.tenantBids.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantBids.status')}
                id="tenant-bids-status"
                name="status"
                data-cy="status"
                type="select"
              >
                {bidStatusValues.map(bidStatus => (
                  <option value={bidStatus} key={bidStatus}>
                    {translate(`tinyMedicRestApp.BidStatus.${bidStatus}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantBids.createdById')}
                id="tenant-bids-createdById"
                name="createdById"
                data-cy="createdById"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantBids.createdByType')}
                id="tenant-bids-createdByType"
                name="createdByType"
                data-cy="createdByType"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantBids.billFor')}
                id="tenant-bids-billFor"
                name="billFor"
                data-cy="billFor"
                type="select"
              >
                {billForValues.map(billFor => (
                  <option value={billFor} key={billFor}>
                    {translate(`tinyMedicRestApp.BillFor.${billFor}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantBids.patientType')}
                id="tenant-bids-patientType"
                name="patientType"
                data-cy="patientType"
                type="select"
              >
                {patientTypeValues.map(patientType => (
                  <option value={patientType} key={patientType}>
                    {translate(`tinyMedicRestApp.PatientType.${patientType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantBids.bidSubmittedDate')}
                id="tenant-bids-bidSubmittedDate"
                name="bidSubmittedDate"
                data-cy="bidSubmittedDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantBids.bidAcceptedDate')}
                id="tenant-bids-bidAcceptedDate"
                name="bidAcceptedDate"
                data-cy="bidAcceptedDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantBids.totalCost')}
                id="tenant-bids-totalCost"
                name="totalCost"
                data-cy="totalCost"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantBids.discount')}
                id="tenant-bids-discount"
                name="discount"
                data-cy="discount"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantBids.cgst')}
                id="tenant-bids-cgst"
                name="cgst"
                data-cy="cgst"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantBids.sgst')}
                id="tenant-bids-sgst"
                name="sgst"
                data-cy="sgst"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantBids.roundOffVal')}
                id="tenant-bids-roundOffVal"
                name="roundOffVal"
                data-cy="roundOffVal"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantBids.active')}
                id="tenant-bids-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantBids.cursor')}
                id="tenant-bids-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantBids.lastUpdated')}
                id="tenant-bids-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantBids.microSec')}
                id="tenant-bids-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantBids.timestampEntry')}
                id="tenant-bids-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantBids.homeDeliveryAvailable')}
                id="tenant-bids-homeDeliveryAvailable"
                name="homeDeliveryAvailable"
                data-cy="homeDeliveryAvailable"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantBids.deliveryTime')}
                id="tenant-bids-deliveryTime"
                name="deliveryTime"
                data-cy="deliveryTime"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantBids.deliveryCost')}
                id="tenant-bids-deliveryCost"
                name="deliveryCost"
                data-cy="deliveryCost"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantBids.grossAmount')}
                id="tenant-bids-grossAmount"
                name="grossAmount"
                data-cy="grossAmount"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantBids.bidNumber')}
                id="tenant-bids-bidNumber"
                name="bidNumber"
                data-cy="bidNumber"
                type="text"
                validate={{
                  maxLength: { value: 50, message: translate('entity.validation.maxlength', { max: 50 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantBids.bidDate')}
                id="tenant-bids-bidDate"
                name="bidDate"
                data-cy="bidDate"
                type="text"
              />
              <ValidatedField
                id="tenant-bids-tinymedicPatientOrder"
                name="tinymedicPatientOrder"
                data-cy="tinymedicPatientOrder"
                label={translate('tinyMedicRestApp.tenantBids.tinymedicPatientOrder')}
                type="select"
              >
                <option value="" key="0" />
                {tinymedicPatientOrders
                  ? tinymedicPatientOrders.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="tenant-bids-tenant"
                name="tenant"
                data-cy="tenant"
                label={translate('tinyMedicRestApp.tenantBids.tenant')}
                type="select"
              >
                <option value="" key="0" />
                {tenants
                  ? tenants.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/tenant-bids" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TenantBidsUpdate;
